export const PATH = '/users-registration';

export const roles = ['tableAreas', 'tableProfiles', 'tableUsers'];
